import React, { useState, useEffect } from 'react';
import logo from '../asserts/hariomlogo.jpg';
import { toast } from 'react-toastify';
import Button from '../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { signin, resetState } from '../slice/userSlice';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, response, message } = useSelector(state => state.user);

    useEffect(() => {
        dispatch(resetState());
    }, [dispatch]);

    useEffect(() => {
        if (response && response?.data?.access_token) {
            if (rememberMe) {
                localStorage.setItem('token', response.data.access_token);
            } else {
                sessionStorage.setItem('token', response.data.access_token);
            }
            navigate('/dashboard');
        } else if (error) {
            toast.error(message || 'Login failed! Please check your credentials.');
        }
    }, [response, error, navigate, message, rememberMe]);

    const loginHandler = async (e) => {
        e.preventDefault();
        if (!username || !password) {
            toast.warn("Please enter both username and password");
            return;
        }
        dispatch(signin({ username, password }));
    };

    const handleRememberMeChange = (e) => {
        setRememberMe(e.target.checked);
    };

    return (
        <section className="sign-in fade-in" style={{ backgroundColor: '#FCF8F2', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-6 col-md-8">
                        <div className="card border-0 shadow-lg" style={{ borderRadius: '30px', overflow: 'hidden' }}>
                            <div className="card-body p-0">
                                <div className="p-5">
                                    <div className="text-center mb-5">
                                        <div className="d-inline-block p-3 rounded-circle mb-3" style={{ background: 'rgba(212, 175, 55, 0.1)' }}>
                                            <img src={logo} alt='Khajuraho Routes' style={{ maxHeight: '60px' }} />
                                        </div>
                                        <h2 className="font-weight-bold" style={{ color: '#1A1A1A' }}>Admin Portal</h2>
                                    </div>
                                    <form className="user" onSubmit={loginHandler}>
                                        <div className="form-group mb-4">
                                            <label htmlFor="usernameInput" className="small font-weight-bold text-dark ml-1">Username / Email</label>
                                            <input
                                                id="usernameInput"
                                                type="text"
                                                className="form-control"
                                                placeholder="admin"
                                                style={{ border: '1px solid #eee', backgroundColor: '#f9f9f9' }}
                                                onChange={(e) => setUsername(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group mb-4">
                                            <label htmlFor="passwordInput" className="small font-weight-bold text-dark ml-1">Password</label>
                                            <div className="password-container" style={{ position: 'relative' }}>
                                                <input
                                                    id="passwordInput"
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="••••••••"
                                                    style={{ border: '1px solid #eee', backgroundColor: '#f9f9f9', paddingRight: '45px' }}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <span
                                                    className="password-eye"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowPassword(!showPassword); }}
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                                    style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d', outline: 'none' }}
                                                >
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="form-group mb-4 d-flex justify-content-between align-items-center">
                                            <div className="custom-control custom-checkbox small">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id="customCheck"
                                                    checked={rememberMe}
                                                    onChange={handleRememberMeChange}
                                                />
                                                <label className="custom-control-label text-muted" htmlFor="customCheck">Remember session</label>
                                            </div>
                                        </div>
                                        <Button
                                            type="submit"
                                            disabled={loading}
                                            className="btn addbtn btn-block py-3"
                                            text={loading ? "Authenticating..." : "Sign In to Dashboard"}
                                        />
                                    </form>
                                    <div className="text-center mt-5">
                                        <p className="small text-muted mb-0"></p>
                                        <div className="d-flex justify-content-center gap-2 mt-2">
                                            <div style={{ width: '30px', height: '2px', backgroundColor: 'var(--primary-gold)', opacity: 0.3 }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Login;
